import {login, logout, getUser, menuAuthResource} from '@/api/login';
import {
    getToken, setToken, removeInfo, setCenter,
    getCenter, setDepart, getDepart, setCity,
    getCity, setName, getName, getEmpCode,getProjectsDate,setProjectsDate,getPosition,setPosition,
    setBrandList,getBrandList,
    setAuthCity,getAuthCity,
    setCooperationMode,getCooperationMode,
    setProjectListByCondiction,getProjectListByCondiction
} from "@/utils/auth";
import watermark from '@/utils/watermark'
import {getProjectCondition, getProjects,projectsByCondition} from "../../api/common";


const user = {
  state: {
    token: getToken(),
    center: getCenter(),
    departName: getDepart(),
    cityCode: getCity(),
    name: getName(),
    position:getPosition(),

    empCode: getEmpCode(),
    projectList:getProjectsDate(),
    // brandList:getBrandList(),
    authCity:getAuthCity(),
    // cooperationMode: getCooperationMode(),
    projectListByCondiction: getProjectListByCondiction()
  },
  mutations: {
    SET_SESSION: (state, token) => {
      state.token = token;
    },
    SET_CENTER: (state, center) => {
      state.center = center;
    },
    SET_DEPARTNAME: (state, departName) => {
      state.departName = departName
    },
    SET_CITYCODE: (state, cityCode) => {
      state.cityCode = cityCode;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_EMPCODE: (state, empCode) => {
      state.empCode = empCode;
    },
    SET_POSITION:(state,position)=>{
      state.position=position
    },
    SET_PROJECTS:(state,data)=>{
        state.projectList=data
    },
    SET_BRANDLIST:(state,brandList) => {
        state.brandList = brandList
    },
    SET_AUTHCITY:(state,data) => {
        state.authCity = data
    },
    SET_COOPERATIONMODE:(state,data) => {
        state.cooperationMode = data
    },
    SET_PROJECTLISTBYCONDICTION:(state,data)=>{
        state.projectListByCondiction = data
    }
  },
  actions: {

    // 登录
    Login({commit, state}, user) {
      return new Promise((resolve, reject) => {
        login({...user,version:1.1}).then(res => {
          commit('SET_SESSION', res.data);
          setToken(res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },
    // 退出
    Logout({commit, state}) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          commit('SET_SESSION', '');
          removeInfo();
          sessionStorage.clear();
          gio('clearUserId');
          resolve(res);


        }).catch(error => {
          reject(error)
        })
      })
    },
   async ProjectList({commit}){
      let res=await getProjects()
      if(!res.data){
       return
     }
     commit('SET_PROJECTS',res.data)
     setProjectsDate(res.data)

    },
    async GetProjectByCondiction({commit}){
        const res = await projectsByCondition({
            brands:[],
            cooperationMode:[],
            cityCodes:[]
        })
        if( !res.data ) return
        commit('SET_PROJECTLISTBYCONDICTION',res.data)
        setProjectListByCondiction(res.data)
    },
    async GetProjectListCondiction({commit}){
        const res = await getProjectCondition()
        if( !res.data ) return
        commit ('SET_BRANDLIST',res.data.brand)
        commit ('SET_AUTHCITY',res.data.authCity)
        commit ('SET_COOPERATIONMODE',res.data.cooperationMode)
        // setBrandList(res.data.brand)
        setAuthCity(res.data.authCity)
        // setCooperationMode(res.data.cooperationMode)
    },
    // 用户信息
    Userinfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getUser().then(res => {
          const data = res.data;
          commit('SET_CENTER', data.center);
          commit('SET_DEPARTNAME', data.departName);
          commit('SET_CITYCODE', data.cityCode);
          commit('SET_NAME', data.empName);
          commit('SET_EMPCODE', data.empCode);
          commit('SET_POSITION',data.position)

          setCenter(data.center);
          setDepart(data.departName);
          setCity(data.cityCode);
          setName(data.empName);
          setPosition(data.position)
          resolve(res);
          watermark.set(data.empName + data.empCode)

          gio('setUserId', data.empCode);

        }).catch(error => {
          reject(error)
        })

        // getProjects().then(res => {
        //   if(!res.data){
        //     return
        //   }
        //   commit('SET_PROJECTS',res.data)
        //   setProjectsDate(res.data)
        //
        //
        // }).catch(error => {
        //   reject(error)
        //
        // })




      })
    },

  },
};

export default user;
